import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  DragSource,
  DropTarget,
} from 'react-dnd'

import './sortable-item.css'


const propTypes = {
  item: PropTypes.object.isRequired,
  Element: PropTypes.object.isRequired,
  useHandle: PropTypes.bool,

  // props for decorators
  // itemType prop is only used by decorator which eslint will throw error for
  /* eslint-disable react/no-unused-prop-types */
  itemType: PropTypes.string.isRequired,
  axis: PropTypes.string.isRequired,
  columnIndex: PropTypes.number.isRequired,
  /* eslint-enable react/no-unused-prop-types */

  isDragging: PropTypes.bool,
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
  connectDropTarget: PropTypes.func,
}

const defaultProps = {
  useHandle: false,

  isDragging: false,
  connectDragSource: (a) => a,
  connectDropTarget: (a) => a,
  connectDragPreview: (a) => a,
}

const cardSource = {
  beginDrag: ({ item, index, columnIndex }) => ({
    item,
    index,
    columnIndex,
  }),
}

const cardTarget = {
  hover: (props, monitor, component) => {
    if (!component.item) {
      return
    }

    const { index: dragIndex, columnIndex: dragColumn } = monitor.getItem()
    const { index: hoverIndex, columnIndex: hoverColumn } = props

    // Don't replace items with themselves
    if (dragIndex === hoverIndex || dragColumn !== hoverColumn) {
      return
    }

    const hoverBoundingRect = component.item.getBoundingClientRect()

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

    // Determine mouse position
    const clientOffset = monitor.getClientOffset()

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%
    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }

    // Time to actually perform the action
    props.moveItem(dragIndex, hoverIndex)
    monitor.getItem().index = hoverIndex
  },
}

const getType = ({ itemType }) => itemType

@DragSource(
  getType,
  cardSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  }),
)
@DropTarget(getType, cardTarget, (connect) => ({ connectDropTarget: connect.dropTarget() }))
class SortableItem extends Component {
  render() {
    const {
      item,
      Element,
      isDragging,
      connectDragSource,
      connectDragPreview,
      connectDropTarget,
      useHandle,
    } = this.props

    const opacity = isDragging ? 0.33 : 1

    const element = (
      <div ref={(ref) => { this.item = ref }} style={{ opacity }} className="item">
        <Element
          item={item}
          isDragging={isDragging}
          connectDragSource={connectDragSource}
          connectDragPreview={connectDragPreview}
        />
      </div>
    )

    if (useHandle) {
      return connectDropTarget(element)
    }

    return connectDropTarget(connectDragSource(element))
  }
}

SortableItem.propTypes = propTypes
SortableItem.defaultProps = defaultProps

export default SortableItem
